export default {
    guidanceEvaluationPerformance: {
        icon: 'file-sync',
        text: 'Bimbingan',
        route: 'admin.evaluation.guidance',
        role: {
            evaluation: ['attendant'],
        }
    },
    scoreEvaluation: {
        icon: 'file-protect',
        text: 'Nilai',
        route: 'admin.evaluation.score',
        role: {
            evaluation: ['attendant'],
        }
    },
    notulenEvaluation: {
        icon: 'file-text',
        text: 'Notulen Evaluasi Kinerja',
        route: 'admin.evaluation.notulen',
        role: {
            evaluation: ['attendant'],
        }
    },
    guidanceEvaluationSummaryMentor: {
        icon: 'file-sync',
        text: 'Validasi Evaluasi Kinerja',
        route: 'admin.evaluation.guidance.summary',
        role: {
            evaluation: ['mentor'],
        }
    },
    guidanceEvaluationSummary: {
        icon: 'file-sync',
        text: 'Bimbingan Evaluasi Kinerja',
        route: 'admin.evaluation.guidance.summary',
        role: {
            evaluation: ['advisor'],
        }
    },
    guidanceEvaluationPerformanceScoring: {
        icon: 'carry-out',
        text: 'Penilaian Evaluasi Kinerja',
        route: 'admin.evaluation.scoring',
        role: {
            evaluation: ['mentor', 'evaluator', 'advisor'],
        }
    },
}